import { OgpApiService } from 'ogp/services/ogp-api-service';
import { Site } from 'shared/hooks';
import {
  DashboardAnalyticsResponse,
  dashboardAnalyticsSchema,
  DashboardTodoResponse,
  dashboardTodoSchema,
  Interval,
  ShiftOverviewChartResponse,
  shiftOverviewChartResponseSchema,
} from './dashboard-service.schema';
import {
  DashboardAnalyticsDto,
  DashboardTodoDto,
  GetShiftOverviewDto,
  IntervalDto,
} from './dashboard-service.dto';

export class DashboardService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getDashboardAnalytics = async (site: Site): Promise<DashboardAnalyticsResponse> => {
    const response = await this.getDashboardAnalyticsImpl(site);
    return dashboardAnalyticsSchema.parse(response);
  };

  public getDashboardAnalyticsImpl = async (site: Site): Promise<DashboardAnalyticsDto> => {
    if (site === 'ogp') {
      return await this.ogpApiService.get<DashboardAnalyticsDto>({
        path: `analytics`,
      });
    }

    throw new Error('Not implemented');
  };

  public getDashboardTodo = async (site: Site): Promise<DashboardTodoResponse> => {
    const response = await this.getDashboardTodoImpl(site);
    return dashboardTodoSchema.parse(response);
  };

  public getDashboardTodoImpl = async (site: Site): Promise<DashboardTodoDto> => {
    if (site === 'ogp') {
      return await this.ogpApiService.get<DashboardTodoDto>({
        path: `todo`,
      });
    }
    throw new Error('Not implemented');
  };

  public async getShiftOverviewChart(
    site: Site,
    startDate: string,
    endDate: string,
    groupBy: Interval
  ): Promise<ShiftOverviewChartResponse> {
    const response = await this.getShiftOverviewChartImpl(site, startDate, endDate, groupBy);

    return shiftOverviewChartResponseSchema.parse(response);
  }
  public getShiftOverviewChartImpl = async (
    site: Site,
    startDate: string,
    endDate: string,
    groupBy: IntervalDto
  ): Promise<GetShiftOverviewDto> => {
    if (site === 'ogp') {
      return await this.ogpApiService.get<GetShiftOverviewDto>({
        path: `shift-overview`,
        params: {
          startDate,
          endDate,
          groupBy,
        },
      });
    }
    throw new Error('Not implemented');
  };
}
